/** User CRUD Modal Component */

import React from 'react';
import {
  Modal, Stack, TextInput, PasswordInput, Select, 
  Button, Group, Checkbox, Group as FormGroup
} from '@mantine/core';

/**
 * User Modal - Create/Edit user
 * 
 * Props:
 * - open: boolean
 * - onClose: function
 * - mode: 'create' | 'edit'
 * - data: object - User form data
 * - onChange: function - Update field
 * - onSubmit: function
 * - loading: boolean
 * - roles: array - Available roles
 */
export const UserModal = ({
  open,
  onClose,
  mode = 'create',
  data = {
    username: '',
    email: '',
    password: '',
    fullName: '',
    role: 'helpdesk_agent',
    phone: '',
    department: ''
  },
  onChange,
  onSubmit,
  loading = false,
  roles = [
    { value: 'helpdesk_agent', label: 'Helpdesk Agent' },
    { value: 'manager', label: 'Manager' },
    { value: 'supervisor', label: 'Supervisor' },
    { value: 'super_admin', label: 'Super Admin' }
  ]
}) => {
  return (
    <Modal
      opened={open}
      onClose={onClose}
      title={mode === 'create' ? 'Add User' : 'Edit User'}
      centered
    >
      <Stack gap="md">
        <TextInput
          label="Full Name"
          placeholder="Enter full name"
          value={data.fullName}
          onChange={(e) => onChange('fullName', e.target.value)}
        />

        <TextInput
          label="Username"
          placeholder="Enter username"
          value={data.username}
          onChange={(e) => onChange('username', e.target.value)}
        />

        <TextInput
          label="Email"
          placeholder="Enter email"
          type="email"
          value={data.email}
          onChange={(e) => onChange('email', e.target.value)}
        />

        {mode === 'create' && (
          <PasswordInput
            label="Password"
            placeholder="Enter password"
            value={data.password}
            onChange={(e) => onChange('password', e.target.value)}
          />
        )}

        <TextInput
          label="Phone"
          placeholder="Enter phone number"
          value={data.phone}
          onChange={(e) => onChange('phone', e.target.value)}
        />

        <TextInput
          label="Department"
          placeholder="Enter department"
          value={data.department}
          onChange={(e) => onChange('department', e.target.value)}
        />

        <Select
          label="Role"
          placeholder="Select role"
          data={roles}
          value={data.role}
          onChange={(val) => onChange('role', val)}
        />

        <Group grow>
          <Button variant="light" onClick={onClose}>
            Cancel
          </Button>
          <Button loading={loading} onClick={onSubmit}>
            {mode === 'create' ? 'Add User' : 'Update User'}
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default UserModal;
